import WithRender from "../../templates/containers/preferredOptionsContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getOptions"]),
    optionsType: () => {
      return "main";
    }
  },
  props: ["hideContainer"]
});
